import { ContactCategory, ContactCategoryDataObject, ContactDataObject, IContact, PhoneBookDataObject } from "../interfaces/contacts"
import { Types } from "../types"
import { ErrorPayLoad, GetListPublicParamsType } from "../types/common/commonTypes"
import {
    AddContactCategoryError, AddContactCategoryRequest, AddContactCategorySuccess, AddContactError, AddContactRequest, AddContactSuccess,
    AddPhoneBookError,
    AddPhoneBookRequest, AddPhoneBookSuccess, ContactListToBlockError, ContactListToBlockRequest, ContactListToBlockSuccess,
    CopyByContactError, CopyByContactRequest, CopyByContactSuccess, CopyByPhonebookError,
    CopyByPhonebookRequest, CopyByPhonebookSuccess, GetAllContactsError, GetAllContactsRequest, GetAllContactsSuccess, GetContactCallDirectError, GetContactCallDirectRequest, GetContactCallDirectSuccess, GetContactCategory, GetContactCategoryError,
    GetContactCategoryRequest, GetContactCategorySuccess, GetContactError, GetContactRequest, GetContactSuccess, GetContactsByPhoneBookIdError, GetContactsByPhoneBookIdRequest, GetContactsByPhoneBookIdSuccess,
    GetPhoneBookError, GetPhoneBookRequest, GetPhoneBookSuccess,
    GetUnpagedContactError,
    GetUnpagedContactRequest,
    GetUnpagedContactSuccess,
    GetUnpagedPhonebookError, GetUnpagedPhonebookRequest, GetUnpagedPhonebookSuccess, MoveByContactError, MoveByContactRequest, MoveByContactSuccess,
    MoveByPhonebookError, MoveByPhonebookRequest, MoveByPhonebookSuccess,
    RemoveContactCategoryError, RemoveContactCategoryRequest, RemoveContactCategorySuccess, RemoveContactError, RemoveContactRequest, RemoveContactSuccess,
    RemoveFromPhoneBookContactError, RemoveFromPhoneBookContactRequest, RemoveFromPhoneBookContactSuccess, RemovePhoneBookError, RemovePhoneBookRequest,
    RemovePhoneBookSuccess, SetContactCategory, UpdateContactCategoryError, UpdateContactCategoryRequest, UpdateContactCategorySuccess, UpdateContactError, UpdateContactRequest,
    UpdateContactSuccess, UpdatePhoneBookError, UpdatePhoneBookRequest, UpdatePhoneBookSuccess
} from "../types/contacts/actionsType"
import {
    AddContactPayloadType, PhonebookStackType, GetContactsByPhoneBookIdPayload, MoveByPhonebookType, ContactStackType, UpdateContactCategoryType,
    UpdateContactPayloadType, UpdatePhoneBookType, removeFromPhoneBookContactPayloadType, ContactStackUpdateBlockType
} from "../types/contacts/apiRequestTypes"


export const getAllContactsRequestAction = (payload: GetListPublicParamsType): GetAllContactsRequest => ({
    type: Types.GET_ALL_CONTACTS_REQUEST,
    payload

})

export const getAllContactsSuccessAction = (response: ContactDataObject): GetAllContactsSuccess => ({
    type: Types.GET_ALL_CONTACTS_SUCCESS,
    response
})

export const getAllContactsErrorAction = (payload: ErrorPayLoad): GetAllContactsError => ({
    type: Types.GET_ALL_CONTACTS_ERROR,
    payload
})


export const getContactRequestAction = (payload: GetListPublicParamsType): GetContactRequest => ({
    type: Types.GET_CONTACT_REQUEST,
    payload

})

export const getContactSuccessAction = (response: ContactDataObject): GetContactSuccess => ({
    type: Types.GET_CONTACT_SUCCESS,
    response
})

export const getContactErrorAction = (payload: ErrorPayLoad): GetContactError => ({
    type: Types.GET_CONTACT_ERROR,
    payload
})



export const getUnpagedContactRequestAction = (payload: GetListPublicParamsType): GetUnpagedContactRequest => ({
    type: Types.GET_UNPAGED_CONTACT_REQUEST,
    payload

})

export const getUnpagedContactSuccessAction = (response: ContactDataObject): GetUnpagedContactSuccess => ({
    type: Types.GET_UNPAGED_CONTACT_SUCCESS,
    response
})

export const getUnpagedContactErrorAction = (payload: ErrorPayLoad): GetUnpagedContactError => ({
    type: Types.GET_UNPAGED_CONTACT_ERROR,
    payload
})



export const getContactsByPhoneBookIdRequestAction = (payload: GetContactsByPhoneBookIdPayload): GetContactsByPhoneBookIdRequest => ({
    type: Types.GET_CONTACTS_BY_PHONE_BOOK_ID_REQUEST,
    payload
})

export const getContactsByPhoneBookIdSuccessAction = (response: IContact[]): GetContactsByPhoneBookIdSuccess => ({
    type: Types.GET_CONTACTS_BY_PHONE_BOOK_ID_SUCCESS,
    response
})

export const getContactsByPhoneBookIdErrorAction = (payload: ErrorPayLoad): GetContactsByPhoneBookIdError => ({
    type: Types.GET_CONTACTS_BY_PHONE_BOOK_ID_ERROR,
    payload
})



export const addContactRequestAction = (payload: AddContactPayloadType): AddContactRequest => ({
    type: Types.ADD_CONTACT_REQUEST,
    payload
})

export const addContactSuccessAction = (): AddContactSuccess => ({
    type: Types.ADD_CONTACT_SUCCESS,

})

export const addContactErrorAction = (payload: ErrorPayLoad): AddContactError => ({
    type: Types.ADD_CONTACT_ERROR,
    payload
})



export const updateContactRequestAction = (payload: UpdateContactPayloadType): UpdateContactRequest => ({
    type: Types.UPDATE_CONTACT_REQUEST,
    payload

})

export const updateContactSuccessAction = (): UpdateContactSuccess => ({
    type: Types.UPDATE_CONTACT_SUCCESS,
})

export const updateContactErrorAction = (payload: ErrorPayLoad): UpdateContactError => ({
    type: Types.UPDATE_CONTACT_ERROR,
    payload
})




export const removeFromPhoneBookContactRequestAction = (payload: removeFromPhoneBookContactPayloadType[]): RemoveFromPhoneBookContactRequest => ({
    type: Types.REMOVE_FROM_PHONE_BOOK_CONTACT_REQUEST,
    payload

})

export const removeFromPhoneBookContactSuccessAction = (): RemoveFromPhoneBookContactSuccess => ({
    type: Types.REMOVE_FROM_PHONE_BOOK_CONTACT_SUCCESS,
})

export const removeFromPhoneBookContactErrorAction = (payload: ErrorPayLoad): RemoveFromPhoneBookContactError => ({
    type: Types.REMOVE_FROM_PHONE_BOOK_CONTACT_ERROR,
    payload
})



export const removeContactRequestAction = (payload: string[]): RemoveContactRequest => ({
    type: Types.REMOVE_CONTACT_REQUEST,
    payload
})

export const removeContactSuccessAction = (): RemoveContactSuccess => ({
    type: Types.REMOVE_CONTACT_SUCCESS,
})

export const removeContactErrorAction = (payload: ErrorPayLoad): RemoveContactError => ({
    type: Types.REMOVE_CONTACT_ERROR,
    payload
})




export const getContactCategoryRequestAction = (payload: GetListPublicParamsType): GetContactCategoryRequest => ({
    type: Types.GET_CONTACT_CATEGORY_REQUEST,
    payload

})

export const getContactCategorySuccessAction = (response: ContactCategoryDataObject): GetContactCategorySuccess => ({
    type: Types.GET_CONTACT_CATEGORY_SUCCESS,
    response
})

export const getContactCategoryErrorAction = (payload: ErrorPayLoad): GetContactCategoryError => ({
    type: Types.GET_CONTACT_CATEGORY_ERROR,
    payload
})



export const AddContactCategoryRequestAction = (payload: string): AddContactCategoryRequest => ({
    type: Types.ADD_CONTACT_CATEGORY_REQUEST,
    payload
})

export const AddContactCategorySuccessAction = (): AddContactCategorySuccess => ({
    type: Types.ADD_CONTACT_CATEGORY_SUCCESS,
})

export const AddContactCategoryErrorAction = (payload: ErrorPayLoad): AddContactCategoryError => ({
    type: Types.ADD_CONTACT_CATEGORY_ERROR,
    payload
})



export const UpdateContactCategoryRequestAction = (payload: UpdateContactCategoryType): UpdateContactCategoryRequest => ({
    type: Types.UPDATE_CONTACT_CATEGORY_REQUEST,
    payload

})

export const UpdateContactCategorySuccessAction = (): UpdateContactCategorySuccess => ({
    type: Types.UPDATE_CONTACT_CATEGORY_SUCCESS,
})

export const UpdateContactCategoryErrorAction = (payload: ErrorPayLoad): UpdateContactCategoryError => ({
    type: Types.UPDATE_CONTACT_CATEGORY_ERROR,
    payload
})


export const RemoveContactCategoryRequestAction = (payload: string): RemoveContactCategoryRequest => ({
    type: Types.REMOVE_CONTACT_CATEGORY_REQUEST,
    payload

})

export const RemoveContactCategorySuccessAction = (): RemoveContactCategorySuccess => ({
    type: Types.REMOVE_CONTACT_CATEGORY_SUCCESS,
})

export const RemoveContactCategoryErrorAction = (payload: ErrorPayLoad): RemoveContactCategoryError => ({
    type: Types.REMOVE_CONTACT_CATEGORY_ERROR,
    payload
})




export const getPhoneBooksRequestAction = (payload: GetListPublicParamsType): GetPhoneBookRequest => ({
    type: Types.GET_PHONE_BOOKS_REQUEST,
    payload

})

export const getPhoneBooksSuccessAction = (response: PhoneBookDataObject): GetPhoneBookSuccess => ({
    type: Types.GET_PHONE_BOOKS_SUCCESS,
    response
})

export const getPhoneBooksErrorAction = (payload: ErrorPayLoad): GetPhoneBookError => ({
    type: Types.GET_PHONE_BOOKS_ERROR,
    payload
})



export const AddPhoneBookRequestAction = (payload: string): AddPhoneBookRequest => ({
    type: Types.ADD_PHONE_BOOK_REQUEST,
    payload

})

export const AddPhoneBookSuccessAction = (): AddPhoneBookSuccess => ({
    type: Types.ADD_PHONE_BOOK_SUCCESS,
})

export const AddPhoneBookErrorAction = (payload: ErrorPayLoad): AddPhoneBookError => ({
    type: Types.ADD_PHONE_BOOK_ERROR,
    payload
})



export const UpdatePhoneBookRequestAction = (payload: UpdatePhoneBookType): UpdatePhoneBookRequest => ({
    type: Types.UPDATE_PHONE_BOOK_REQUEST,
    payload

})

export const UpdatePhoneBookSuccessAction = (): UpdatePhoneBookSuccess => ({
    type: Types.UPDATE_PHONE_BOOK_SUCCESS,
})

export const UpdatePhoneBookErrorAction = (payload: ErrorPayLoad): UpdatePhoneBookError => ({
    type: Types.UPDATE_PHONE_BOOK_ERROR,
    payload
})



export const removePhoneBookRequestAction = (payload: string): RemovePhoneBookRequest => ({
    type: Types.DELETE_PHONE_BOOK_REQUEST,
    payload
})

export const removePhoneBookSuccessAction = (): RemovePhoneBookSuccess => ({
    type: Types.DELETE_PHONE_BOOK_SUCCESS,
})

export const removePhoneBookErrorAction = (payload: ErrorPayLoad): RemovePhoneBookError => ({
    type: Types.DELETE_PHONE_BOOK_ERROR,
    payload
})


export const CopyByPhonebookRequestAction = (payload: PhonebookStackType): CopyByPhonebookRequest => ({
    type: Types.COPY_BY_PHONEBOOK_REQUEST,
    payload
})

export const CopyByPhonebookSuccessAction = (): CopyByPhonebookSuccess => ({
    type: Types.COPY_BY_PHONEBOOK_SUCCESS,
})

export const CopyByPhonebookErrorAction = (payload: ErrorPayLoad): CopyByPhonebookError => ({
    type: Types.COPY_BY_PHONEBOOK_ERROR,
    payload
})

export const MoveByPhonebookRequestAction = (payload: PhonebookStackType): MoveByPhonebookRequest => ({
    type: Types.MOVE_BY_PHONEBOOK_REQUEST,
    payload
})

export const MoveByPhonebookSuccessAction = (): MoveByPhonebookSuccess => ({
    type: Types.MOVE_BY_PHONEBOOK_SUCCESS,
})

export const MoveByPhonebookErrorAction = (payload: ErrorPayLoad): MoveByPhonebookError => ({
    type: Types.MOVE_BY_PHONEBOOK_ERROR,
    payload
})


export const GetUnpagedPhonebookRequestAction = (payload: GetListPublicParamsType): GetUnpagedPhonebookRequest => ({
    type: Types.GET_PHONEBOOK_UNPAGED_REQUEST,
    payload
})

export const GetUnpagedPhonebookSuccessAction = (response: PhoneBookDataObject): GetUnpagedPhonebookSuccess => ({
    type: Types.GET_PHONEBOOK_UNPAGED_SUCCESS,
    response
})

export const GetUnpagedPhonebookErrorAction = (payload: ErrorPayLoad): GetUnpagedPhonebookError => ({
    type: Types.GET_PHONEBOOK_UNPAGED_ERROR,
    payload
})



export const resetContactPropsAction = () => ({
    type: Types.RESET_CONTACT_PROPS,
})



export const CopyByContactRequestAction = (payload: ContactStackType): CopyByContactRequest => ({
    type: Types.COPY_BY_CONTACT_REQUEST,
    payload
})

export const CopyByContactSuccessAction = (): CopyByContactSuccess => ({
    type: Types.COPY_BY_CONTACT_SUCCESS,
})

export const CopyByContactErrorAction = (payload: ErrorPayLoad): CopyByContactError => ({
    type: Types.COPY_BY_CONTACT_ERROR,
    payload
})

export const MoveByContactRequestAction = (payload: ContactStackType): MoveByContactRequest => ({
    type: Types.MOVE_BY_CONTACT_REQUEST,
    payload
})

export const MoveByContactSuccessAction = (): MoveByContactSuccess => ({
    type: Types.MOVE_BY_CONTACT_SUCCESS,
})

export const MoveByContactErrorAction = (payload: ErrorPayLoad): MoveByContactError => ({
    type: Types.MOVE_BY_CONTACT_ERROR,
    payload
})



export const ContactListToBlockRequestAction = (payload: ContactStackUpdateBlockType): ContactListToBlockRequest => ({
    type: Types.CONTACT_LIST_TO_BLOCK_REQUEST,
    payload
})

export const ContactListToBlockSuccessAction = (): ContactListToBlockSuccess => ({
    type: Types.CONTACT_LIST_TO_BLOCK_SUCCESS,
})

export const ContactListToBlockErrorAction = (payload: ErrorPayLoad): ContactListToBlockError => ({
    type: Types.CONTACT_LIST_TO_BLOCK_ERROR,
    payload
})



export const SetSelectedContactCategoryAction = (payload: ContactCategory | null): SetContactCategory => ({
    type: Types.SET_SELECTED_CONTACT_CATEGORY,
    payload
})

//*Call direct*********************************************************************************************************** */

export const getContactCallDirectRequestAction = (payload: GetListPublicParamsType): GetContactCallDirectRequest => ({
    type: Types.GET_CONTACT_CALL_DIRECT_REQUEST,
    payload

})

export const getContactCallDirectSuccessAction = (response: ContactDataObject): GetContactCallDirectSuccess => ({
    type: Types.GET_CONTACT_CALL_DIRECT_SUCCESS,
    response
})

export const getContactCallDirectErrorAction = (payload: ErrorPayLoad): GetContactCallDirectError => ({
    type: Types.GET_CONTACT_CALL_DIRECT_ERROR,
    payload
})

export const getContactCallDirectReset=()=>({
    type:Types.GET_CONTACT_CALL_DIRECT_RESET
})




